import { CORE_VALUES } from "@/data/site";

export default function ValuesBento() {
  return (
    <section data-testid="values-bento" className="py-24 md:py-32 bg-teh-surfaceAlt">
      <div className="teh-container">
        <div className="max-w-3xl mb-16">
          <p className="teh-overline">What We Stand For</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 text-teh-deep leading-[1.05] tracking-tight">
            Eight values.
            <br />
            <span className="italic text-teh-green">One promise:</span> to do this work well.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {CORE_VALUES.map((v, i) => (
            <div
              key={v.title}
              data-testid={`value-card-${v.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="group relative p-7 bg-white border border-teh-navy/10 hover:border-teh-green/40 transition-all duration-500 overflow-hidden"
              style={{
                borderRadius: i % 3 === 0 ? "24px 4px 24px 4px" : "4px 24px 4px 24px",
              }}
            >
              <div className="flex items-center justify-between mb-6">
                <span className="font-serif text-2xl text-teh-green">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="h-px flex-1 ml-4 bg-teh-navy/10 group-hover:bg-teh-green/50 transition-colors" />
              </div>
              <h3 className="font-serif text-2xl text-teh-deep mb-3">{v.title}</h3>
              <p className="text-sm text-teh-muted leading-relaxed">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
